<template>
  <header
    class="main-header"
    v-if="!mediaQueries.large || $route.name !== 'cart'"
  >
    <section class="container">
      <!-- top section -->

      <div class="padding-b-10 top-header-section" id="fixedHeaderSection">
        <div
          class="row d-flex align-items-center top-header container justify-content-between mx-auto"
        >
          <!-- hamburger menu -->
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center">
              <NavButton
                class="d-block d-xl-none"
                @click="allCategoriesClose"
              />
              <AtlasLogo />
            </div>
          </div>
          <div class="d-none d-xl-flex pr-4" style="flex-grow: 1">
            <SearchButton class="bg-none" style="width: 500px" />
          </div>

          <div
            class="d-flex align-items-center flex-row-reverse flex-lg-row"
            :class="
              isLogin
                ? 'justify-content-between gap-10'
                : 'justify-content-end gap-14'
            "
          >
            <!-- cart -->
            <CartButton class="" />
            <!-- login -->
            <span v-show="isLogin && !isLogin">{{ isLogin }}</span>
            <div class="d-flex">
              <!-- اگر لاگین نبود ایکن ورود نمایش داده شود -->
              <button
                v-if="!isLogin"
                id="loginButton"
                type="button"
                class="d-flex flex-column align-items-center bg-none"
                data-toggle="modal"
                data-target="#loginModal"
                style="gap: 8px"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="11.5789"
                    cy="7.27803"
                    r="4.77803"
                    stroke="#F83D84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.00002 18.7014C3.99873 18.3655 4.07385 18.0337 4.2197 17.7311C4.67736 16.8158 5.96798 16.3307 7.03892 16.111C7.81128 15.9462 8.59431 15.836 9.38217 15.7815C10.8408 15.6533 12.3079 15.6533 13.7666 15.7815C14.5544 15.8367 15.3374 15.9468 16.1099 16.111C17.1808 16.3307 18.4714 16.77 18.9291 17.7311C19.2224 18.3479 19.2224 19.064 18.9291 19.6808C18.4714 20.6419 17.1808 21.0812 16.1099 21.2918C15.3384 21.4634 14.5551 21.5766 13.7666 21.6304C12.5794 21.7311 11.3866 21.7494 10.1968 21.6854C9.92221 21.6854 9.65677 21.6854 9.38217 21.6304C8.59663 21.5773 7.81632 21.4641 7.04807 21.2918C5.96798 21.0812 4.68652 20.6419 4.2197 19.6808C4.0746 19.3747 3.99955 19.0401 4.00002 18.7014Z"
                    stroke="#F83D84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <!--                <span class="font-s-12 text-color-theme">ورود / عضویت</span>-->
              </button>
              <button class="bg-trancparent" v-if="isLogin">
                <LoginUser :atlasTheme="false" />
              </button>
            </div>
            <!-- <span class="divider "></span> -->

            <button
              type="button"
              class="bg-none d-md-none d-flex"
              @click="showCloseSearchBox()"
            >
              <span class="d-flex align-items-center gap-10">
                <svg
                  @click.prevent="gotoSearchPage"
                  width="18"
                  height="17"
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.3049 4.35233H10.1467C9.86258 4.35233 9.62695 4.1167 9.62695 3.83256C9.62695 3.54842 9.86258 3.3128 10.1467 3.3128H14.3049C14.589 3.3128 14.8246 3.54842 14.8246 3.83256C14.8246 4.1167 14.589 4.35233 14.3049 4.35233Z"
                    fill="#F83D84"
                  />
                  <path
                    d="M12.2258 6.43142H10.1467C9.86258 6.43142 9.62695 6.1958 9.62695 5.91166C9.62695 5.62752 9.86258 5.39189 10.1467 5.39189H12.2258C12.5099 5.39189 12.7456 5.62752 12.7456 5.91166C12.7456 6.1958 12.5099 6.43142 12.2258 6.43142Z"
                    fill="#F83D84"
                  />
                  <path
                    d="M8.41599 15.4407C4.50041 15.4407 1.3125 12.2528 1.3125 8.33719C1.3125 4.42161 4.50041 1.2337 8.41599 1.2337C8.70013 1.2337 8.93576 1.46933 8.93576 1.75347C8.93576 2.03761 8.70013 2.27324 8.41599 2.27324C5.06869 2.27324 2.35203 4.99682 2.35203 8.33719C2.35203 11.6776 5.06869 14.4011 8.41599 14.4011C11.7633 14.4011 14.4799 11.6776 14.4799 8.33719C14.4799 8.05305 14.7156 7.81742 14.9997 7.81742C15.2838 7.81742 15.5195 8.05305 15.5195 8.33719C15.5195 12.2528 12.3316 15.4407 8.41599 15.4407Z"
                    fill="#F83D84"
                  />
                  <path
                    d="M15.6931 16.1337C15.5615 16.1337 15.4298 16.0852 15.3258 15.9812L13.9398 14.5952C13.7388 14.3942 13.7388 14.0616 13.9398 13.8606C14.1408 13.6596 14.4734 13.6596 14.6744 13.8606L16.0604 15.2466C16.2614 15.4476 16.2614 15.7802 16.0604 15.9812C15.9565 16.0852 15.8248 16.1337 15.6931 16.1337Z"
                    fill="#F83D84"
                  />
                </svg>
              </span>
            </button>
            <!-- notification -->
            <div
              v-if="isLogin && notifications && notifications.items"
              class="d-sm-flex d-none align-items-center flex-column"
            >
              <figure
                class="m-0"
                v-if="
                  isLogin &&
                  notifications &&
                  notifications.items &&
                  !notifications.items.length
                "
              >
                <img
                  class="cursor-pointer"
                  @click="
                    $root.notify('پیامی برای مشاهده یافت نشد!', 'warning')
                  "
                  width="22"
                  height="22"
                  src="../../../../assets/images/bell.svg"
                  alt=""
                />
              </figure>
              <div
                v-else
                class="d-md-inline-block d-none"
                :class="
                  notifications &&
                  notifications.items &&
                  notifications.items.length > 0
                    ? 'ml-4'
                    : 'ml-0'
                "
              >
                <HeaderNotification
                  v-if="
                    notifications &&
                    notifications.items &&
                    notifications.items.length > 0
                  "
                  :value="notifications"
                />
              </div>
              <!--              <span class="font-s-12 text-color-theme pt-1">پیام ها</span>-->
            </div>
          </div>
        </div>
      </div>
      <!-- bottom section -->

      <div
        class="d-xl-flex d-none align-items-center justify-content-md-between padding-t-10"
      >
        <Nav class="d-none d-xl-block"></Nav>
        <!-- <div class="d-flex align-items-center justify-content-between gap-10">
          <div class="d-flex align-items-center">
            <p class="m-0 font-weight-bold fontsize-mini">پشتیبانی</p>
          </div>
          <div
              class="d-flex align-items-center gap-10 bg-color-eai border-r-25"
          >
            <a
                class="fontsize-mini text-light bg-color-theme padding-t-2 padding-b-2 padding-r-10 padding-l-10"
                style="border-radius: 25px 25px 25px 0"
                :href="`tel:${
                content?.settings?.site?.mobile_support.split('-')[0]
              }`"
            >{{ content?.settings?.site?.mobile_support.split("-")[0] }}</a
            >
            
          </div>
        </div> -->
      </div>

      <!-- search box mobile -->
      <!-- <SearchButton class="bg-none d-flex d-xl-none mt-4 mt-xl-0" /> -->
    </section>

    <MainSearch></MainSearch>
    <RespLoginModal></RespLoginModal>
    <CartLists></CartLists>
    <RespMenu ref="respMenu"></RespMenu>
      
    <!-- <portal to="destination" >
        <transition name="mobile-fade">
          <mobileMenu
            v-if="showMenuMobile"
            :showMenuMobile="showMenuMobile"
            @closeMenuMobile="showMenuMobile = false"
          ></mobileMenu>
        </transition>
    </portal> -->
    <div
      id="header_bg_img"
      :class="{ 'ClubDetail-header_bg_img': $route.name == 'ClubDetail' }"
    >
      <img class="w-100" src="../../../../assets/images/headerbg.png" alt="" />
    </div>
  </header>
</template>

<script>
import { Portal } from 'portal-vue';
import AtlasLogo from "@/parts/Front/components/AtlasLogo";
import Nav from "@/parts/Front/components/Nav";
// import ProductCategories from "@/parts/Front/components/ProductCategories";
import RespMenu from "@/parts/Front/components/RespMenu";
import mobileMenu from "@/parts/Front/components/mobileMenu";
import MainSearch from "@/parts/Front/components/MainSearch";
import LoginUser from "@/parts/Front/components/LoginUser";
import RespLoginModal from "@/parts/Front/components/RespLoginModal";
import CartLists from "@/parts/Front/components/CartLists";
import HeaderNotification from "@/parts/Front/components/notification/HeaderNotification";
import CartButton from "@/parts/Front/components/cart/CartButton";
import SearchButton from "../header/SearchButton";
import NavButton from "@/parts/Front/components/shared/NavButton";
import { openSearch } from "../../../../libraries/functions";
import cart from "@/parts/Front/components/cart/cart";
import bell from "@/assets/images/bell.svg";

export default {
  name: "Header",
  components: {
    Portal,
    NavButton,
    SearchButton,
    AtlasLogo,
    HeaderNotification,
    Nav,
    LoginUser,
    // ProductCategories,
    RespMenu,
    mobileMenu,
    MainSearch,
    RespLoginModal,
    CartLists,
    CartButton,
    bell,
  },
  inject: ["mediaQueries"],
  methods: {
    allCategoriesClose() {
      this.$refs.respMenu.allCategoriesToggle();
    },
    signout() {
      window
        .swal({
          title: "آیا میخواهید خارج شوید؟",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله خارج شو"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.disabledlLogout = true;
            this.$axios.post("/customer/logout").then((res) => {
              this.disabledlLogout = false;
              this.showOptions = false;
              // پاک کردن اطلاعات مربوط به کاربر از کوکی و ویو ایکس
              delete this.$axios.defaults.headers.common["Authorization"];
              this.$root.deleteCookie("Authorization");
              this.$store.commit("front/setLoginStatus", false);
              if (this.cart) {
                this.cart.emptyCookie();
              }
            });
          }
        });
    },
    isScroll() {
      if (scrollY > 150) {
        document
          .getElementById("fixedHeaderSection")
          .classList.add("fixedHeader");
      } else {
        document
          .getElementById("fixedHeaderSection")
          .classList.remove("fixedHeader");
      }
    },
    showCloseSearchBox() {
      openSearch();
    },
  },
  mounted() {
    if (this.isLogin) {
      this.$store.dispatch("front/getNotficationsFromServer");
    }
    window.addEventListener("scroll", this.isScroll);
  },
  computed: {
    // چک کردن لاگین بودن کاربر با استفاده از ویو ایکس در سند یوزر
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    // دریافت اطلاعات کاربر
    FullName() {
      return this.$store.getters["front/getFullName"];
    },
    notifications() {
      return this.$store.getters["front/getNotifications"];
    },
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    cart() {
      if (this.$store.getters["front/getHomeData"]) {
        return this.$store.getters["front/getHomeData"].user.cart;
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      disabledlLogout: false,
      showMenuMobile: false,
    };
  },
};
</script>

<style scoped>
.mobile-fade-enter-active {
   animation: Menu 0.3s linear;

}
.mobile-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  animation: Menu 0.3s linear reverse;
}
@keyframes Menu {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.top-header-section {
  border-bottom: 2px dashed var(--color-border);
}
#header_bg_img {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: -1;
  height: 100%;
}

.ClubDetail-header_bg_img img {
  height: 400px;
}

.main-header {
  /* background-color: rgb(250, 250, 250); */
  padding-top: 20px;
  padding-bottom: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

div#logoBack {
  position: absolute;
  background: white;
  width: 170px;
  height: 80px;
  z-index: -1;
  border-radius: 0 0 20px 20px;
  top: -1rem;
  right: -15px;
}

.fixedHeader {
  position: fixed;
  top: -50px;
  background: #ffffff;
  right: 0;
  left: 0;
  z-index: 1040;
  padding: 10px 14px;
  animation: fixedHeaderAnimation 0.5s linear forwards;
  border-bottom: unset !important;
}

.divider {
  width: 2px;
  height: 20px;
  background: var(--color-themepinkyMelo);
}

@keyframes fixedHeaderAnimation {
  0% {
    top: -50px;
  }
  100% {
    top: 0;
  }
}

@media screen and (min-width: 770px) {
  .fixedHeader > div {
    width: 90%;
    margin-inline: auto;
  }
}

@media screen and (max-width: 769px) {
  #header_bg_img img {
    height: 100%;
  }

  #header_bg_img.ClubDetail-header_bg_img img {
    height: 410px;
  }
}

@media screen and (max-width: 1250px) {
  .ClubDetail-header_bg_img img {
    height: 460px;
  }
}

@media screen and (max-width: 1000px) {
  .ClubDetail-header_bg_img img {
    height: 410px;
  }
}
@media screen and (max-width: 600px) {
  .main-header {
    padding-top: 0px;
    padding-bottom: 10px;
  }
  .top-header {
    padding-inline: 0 !important;
  }
  .top-header-section {
    border-bottom: unset;
  }
  .top-header-section {
    padding-bottom: 4px;
  }
}
</style>
